import logError from 'src/data/services/logError';
import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import Colors from 'src/core/utils/Colors';
import Images from 'src/core/utils/Images';
import Translations from 'src/core/utils/Translations';
import Dimens from 'src/core/utils/Dimens';

interface FooterProps {
	backgroundType?: string;
	backgroundColor?: string;
	backgroundImage?: string;
}

export default function Footer({ backgroundType, backgroundColor, backgroundImage }: FooterProps) {
	const insets = useSafeAreaInsets();
	const { openUrlInternally } = useServicesStore();
	// Reserve the bottom safe area (Android system buttons / iOS home indicator) so the footer does not fall
	// behind the navigation buttons. An image fills that strip itself: padded, it stopped at 35pt and the
	// transparent remainder showed the list scrolling through underneath it (#430).
	const footerInset = {
		height: 35 + insets.bottom,
		paddingBottom: backgroundType === 'image' ? 0 : insets.bottom,
	};

	const openTopicus = () => openUrlInternally({ url: Translations.urlTopicus }).catch(logError);

	if (backgroundType === 'default') {
		return (
			<View style={[styles.footer, styles.footerWithLogo, footerInset]} testID="footer">
				<TouchableOpacity style={styles.logoTouchable} onPress={openTopicus}>
					<Image source={Images.footerLogo} style={styles.footerLogo} />
				</TouchableOpacity>
			</View>
		);
	} else {
		return (
			<View
				style={[
					styles.footer,
					footerInset,
					{
						backgroundColor: backgroundColor && backgroundType === 'solid' ? backgroundColor : Colors.transparent,
					},
				]}
				testID="footer"
			>
				{backgroundImage && backgroundType === 'image' ? (
					<Image resizeMode={'cover'} source={{ uri: backgroundImage }} style={styles.footerBackground} />
				) : null}
			</View>
		);
	}
}

const styles = StyleSheet.create({
	footer: {
		flex: 1,
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		height: 35,
		alignSelf: 'flex-end',
		zIndex: 4,
	},
	footerWithLogo: {
		justifyContent: 'center',
		backgroundColor: Colors.primary,
	},
	footerBackground: {
		flex: 1,
	},
	logoTouchable: {
		alignSelf: 'flex-end',
		marginRight: Dimens.margin24,
	},
	footerLogo: {
		resizeMode: 'contain',
		width: 125,
		tintColor: Colors.secondary,
	},
});
